import { useFeatureAvailable } from 'App/components/hooks';
import { Feature } from 'Store/actions/FeatureHelperActions';

export default function useListLeadsAllowed() {
	return useFeatureAvailable(Feature.LEADS);
}
